import CadPreview from './CadPreview'
import DocViewerPreview from './DocViewerPreview'
import { CAD_PREVIEW_EXTENSIONS } from '../../../../utility/fileUtil'

/**
 * FileViewer
 *
 * Single entry point for all file previews across the platform.
 * Automatically routes to the correct renderer based on file extension:
 *   - CAD files (dwg, dxf, dwt, dws) → CadPreview (DXF viewer with toolbar & layers)
 *   - Everything else               → DocViewerPreview (PDF, images, Office, CSV, HTML, etc.)
 *
 * Props:
 *   open       {boolean}   – whether the dialog is open
 *   onClose    {function}  – called when the user closes the dialog
 *   fileKey    {string}    – S3 object key, e.g. "files/report.pdf" or "files/plan.dwg"
 *   user       {object}    – auth user object with `token`
 *   onDownload {function}  – optional download handler (used in non-CAD fallback messages)
 */
const FileViewer = ({ open, onClose, fileKey, user, onDownload }) => {
  if (!fileKey || typeof fileKey !== 'string') return null

  const ext = fileKey?.split('.').pop()?.toLowerCase() ?? ''
  const isCad = CAD_PREVIEW_EXTENSIONS.includes(ext)

  if (isCad) {
    return <CadPreview open={open} onClose={onClose} fileKey={fileKey} user={user} />
  }

  return (
    <DocViewerPreview
      open={open}
      onClose={onClose}
      fileKey={fileKey}
      user={user}
      onDownload={onDownload}
    />
  )
}

export default FileViewer
